import Vue from 'vue'
import App from './App.vue'
import router from './router'
import echarts from 'echarts'
import store from './store'
import i18n from './i18n'
import locale from 'element-ui/lib/locale/lang/zh-TW'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import FBSignInButton from 'vue-facebook-signin-button'
import excel from 'vue-excel-export'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faChartLine, faUser, faReceipt, faGear, faPodcast, faShare, faMessage, faStore, faTag } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faChartLine)
library.add(faUser)
library.add(faReceipt)
library.add(faGear)
library.add(faPodcast)
library.add(faShare)
library.add(faMessage)
library.add(faStore)
library.add(faTag)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(FBSignInButton)

//Vue.use(ElementUI);
Vue.use(ElementUI, { locale })
Vue.use(excel)
Vue.config.productionTip = false

Vue.prototype.$echarts = echarts

var user = JSON.parse(window.localStorage.getItem('user')) || ''
var userinfo = JSON.parse(window.localStorage.getItem('userinfo')) || ''
if (!user || !userinfo) {
    window.location.hash = '#/login'
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
